import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Shield, Lock, FileCheck } from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

const Signup = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/payment');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <nav className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-xl font-bold text-gray-900">
              SecureFiles
            </Link>
            
            <NavigationMenu>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <Link to="/who-we-are">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Who We Are
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/support">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Support
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/login">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Login
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>
        </div>
      </nav>

      <div className="py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Secure File Management Made Simple
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Join thousands of users who trust us with their sensitive files
            </p>
            <Button 
              size="lg"
              onClick={handleGetStarted}
              className="bg-primary hover:bg-primary/90"
            >
              View Our Plans
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <Shield className="w-12 h-12 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2">Enterprise-Grade Security</h3>
              <p className="text-gray-600">
                Your files are protected with state-of-the-art encryption technology
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <Lock className="w-12 h-12 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2">Private Access Control</h3>
              <p className="text-gray-600">
                Manage who can access your files with granular permissions
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <FileCheck className="w-12 h-12 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2">Easy File Management</h3>
              <p className="text-gray-600">
                Upload, organize, and share files with just a few clicks
              </p>
            </div>
          </div>

          <div className="text-center mt-16">
            <h2 className="text-2xl font-bold mb-4">Ready to get started?</h2>
            <p className="text-gray-600 mb-8">
              Choose a plan that works for you and start securing your files today.
            </p>
            <Button 
              size="lg"
              onClick={handleGetStarted}
              className="bg-primary hover:bg-primary/90"
            >
              View Pricing Plans
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;